import { render, staticRenderFns } from "./reformCatalogList.vue?vue&type=template&id=00423c70&scoped=true"
import script from "./reformCatalogList.vue?vue&type=script&lang=js"
export * from "./reformCatalogList.vue?vue&type=script&lang=js"
import style0 from "./reformCatalogList.vue?vue&type=style&index=0&id=00423c70&prod&lang=css"
import style1 from "./reformCatalogList.vue?vue&type=style&index=1&id=00423c70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00423c70",
  null
  
)

export default component.exports